import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_provider/provider/jobs/offers/")({
  beforeLoad: () => {
    // Redirect to the consolidated My Jobs page
    throw redirect({
      to: "/provider/jobs/active",
      replace: true,
    });
  },
  component: () => null,
});
